export const loadRecaptcha = () => {
  if(!window.grecaptcha) {  
    console.info("Recaptcha has been loaded");
    let head = document.getElementsByTagName("head")[0];
    let script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.GATSBY_RECAPTCHA_SITE_KEY}`;
    head.appendChild(script);
  }
};
